export const CITY_REGISTRY = {
  lehigh_valley: {
    id: 'lehigh_valley',
    label: 'Lehigh Valley',
    shortCode: 'LV',
    year: '2026',
    festival: 'Musikfest',
    primaryVenue: 'SteelStacks',
    secondaryVenue: 'Wind Creek',
    defaultStageLabel: 'SteelStacks Stage',
    heroImage: '/images/trexlertown_velodrome_signal.jpg',
    status: 'ACTIVE',
    stampText: 'LV 2026',
    schedulePhrase: 'follow the Musikfest signal trail',
    glowColor: '#D37633', // Brand Orange
  },

  nyc: {
    id: 'nyc',
    label: 'New York City',
    shortCode: 'NYC',
    year: '2026',
    festival: 'Winter Jazzfest',
    primaryVenue: 'Kismat',
    defaultStageLabel: 'Kismat Stage',
    heroImage: '/images/01_newyork.jpg',
    status: 'ACTIVE',
    stampText: 'NYC 2026',
    schedulePhrase: 'follow the Winter Jazzfest signal trail',
    glowColor: '#38bdf8', // Cyan
  },

  rochester: {
    id: 'rochester',
    label: 'Rochester',
    shortCode: 'ROC',
    year: '2026',
    festival: 'Rochester Fringe Festival',
    primaryVenue: 'Parcel 5',
    defaultStageLabel: 'Rochester Fringe Stage',
    heroImage: '/images/hudson_valley_nexus.jpg',
    status: 'ACTIVE',
    stampText: 'ROC 2026',
    schedulePhrase: 'follow the Rochester Fringe signal trail',
    glowColor: '#E0167C',
  },

  birmingham: {
    id: 'birmingham',
    label: 'Birmingham',
    shortCode: 'BHM',
    year: '2026',
    festival: "Birmingham Folk n' Roll Grid",
    primaryVenue: 'The Nick',
    secondaryVenue: 'Dial Back Sound',
    defaultStageLabel: 'Birmingham Field Stage',
    heroImage: '/images/tvisio_logo.webp',
    status: 'SIGNAL STANDBY',
    stampText: 'BHM 2026',
    schedulePhrase: 'follow the Birmingham field signal',
    glowColor: '#D37633',
  },

  montreal: {
    id: 'montreal',
    label: 'Montreal',
    shortCode: 'MTL',
    year: '2026',
    festival: 'FIJM',
    primaryVenue: 'Place des Festivals',
    defaultStageLabel: 'FIJM Main Stage',
    heroImage: '/images/place_des_festivals_jazz.jpg',
    status: 'LIVE NOW',
    stampText: 'MTL 2026',
    schedulePhrase: 'follow the FIJM signal trail',
    glowColor: '#00E3FD', // Brand Cyan
  },

  rtm: {
    id: 'rtm',
    label: 'Rototom Sunsplash',
    shortCode: 'RTM',
    year: '2026',
    festival: 'Yetibeb Moged Show',
    primaryVenue: 'House of Rastafari',
    defaultStageLabel: 'House of Rastafari Stage',
    heroImage: '/images/rototom_main_stage.png',
    status: 'LIVE NOW',
    stampText: 'RTM 2026',
    schedulePhrase: 'follow the Yetibeb Moged & Rototom signal trail',
    glowColor: '#10B981', // Emerald Green
  },
  laurentian: {
    id: 'laurentian',
    label: 'Laurentian Borderlands',
    shortCode: 'LRT',
    year: '2026',
    festival: 'Boreal Ephemera',
    primaryVenue: 'The Dog Still Listening',
    defaultStageLabel: 'Roadside Stage',
    heroImage: '/images/laurentian_borderlands.jpg',
    status: 'ACTIVE',
    stampText: 'LRT 2026',
    schedulePhrase: 'follow the boreal ephemera trail',
    glowColor: '#10b981', // Emerald Green
  },

  all: {
    id: 'all',
    label: 'All Regions',
    shortCode: 'ALL',
    year: '2026',
    festival: 'Living Cultural Corridor Circuit',
    primaryVenue: 'Network Radar',
    defaultStageLabel: 'All Active Transmissions',
    heroImage: '/images/01_newyork.jpg',
    status: 'LIVE NOW',
    stampText: 'ALL 2026',
    schedulePhrase: 'explore the full cultural corridor circuit',
    glowColor: '#00E3FD', // Brand Cyan
  },
};

export const DEFAULT_CITY_ID = 'nyc';

export function normalizeCityId(cityId) {
  if (!cityId) return DEFAULT_CITY_ID;
  const clean = String(cityId).trim();
  const lower = clean.toLowerCase();
  if (lower === 'all' || lower === 'all-regions' || lower === 'all_regions') return 'all';
  if (lower === 'lvpa' || lower === 'lehigh-valley') return 'lehigh_valley';
  if (lower === 'new-york' || lower === 'new_york') return 'nyc';
  if (lower === 'mtl' || lower === 'montréal') return 'montreal';
  if (lower === 'rtm' || lower === 'rototom') return 'rtm';
  if (lower === 'roc' || lower === 'rochester_fringe' || lower === 'rochester-fringe') return 'rochester';
  return CITY_REGISTRY[clean] ? clean : (CITY_REGISTRY[lower] ? lower : DEFAULT_CITY_ID);
}

export function getCityConfig(cityId) {
  return CITY_REGISTRY[normalizeCityId(cityId)];
}

export function getCityHeroImage(cityId) {
  return getCityConfig(cityId).heroImage;
}
